var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useRef, useState } from 'react';
import { Button, Checkboxes, DropdownClose, DropdownDownArrow, fontTokens, GBTypography, TextInput, searchThroughOptions } from '@leapfinance/geebee-component-library';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { Divider, IconButton, Popover } from '@mui/material';
import classNames from 'classnames';
import { isFalsy } from '../../../../utils/common';
import { showHighOfferChangesOptions } from '../utils';
import useCFFilters from './useCFFilters';
var UniversityCFFilter = function (props) {
    var _a, _b, _c;
    var _d = __read(useState([]), 2), filteredUniversityOptions = _d[0], setFilteredUniversityOptions = _d[1];
    var _e = __read(useState(''), 2), searchQuery = _e[0], setSearchQuery = _e[1];
    var _f = useCFFilters({}), highOfferInstituteValue = _f.highOfferInstituteValue, universitiesValues = _f.universitiesValues, getUniversityOptions = _f.getUniversityOptions;
    var _g = __read(useState([]), 2), universityValues = _g[0], setUniversityValues = _g[1];
    var _h = __read(React.useState(null), 2), anchorEl = _h[0], setAnchorEl = _h[1];
    var open = Boolean(anchorEl);
    var id = open ? 'university-cf-filter-popover' : undefined;
    var inputRef = useRef(null);
    var universityOptions = React.useMemo(function () { var _a; return (_a = getUniversityOptions(props.universityAggregationData)) !== null && _a !== void 0 ? _a : []; }, [props.universityAggregationData]);
    useEffect(function () {
        setUniversityValues(universitiesValues !== null && universitiesValues !== void 0 ? universitiesValues : []);
    }, [universitiesValues]);
    useEffect(function () {
        setFilteredUniversityOptions(searchThroughOptions(searchQuery, universityOptions, function (o) { return o.label; }));
    }, [searchQuery]);
    var handleClose = function (isApplied) {
        setAnchorEl(null);
        setSearchQuery('');
        setTimeout(function () {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }, 0);
        if (!isApplied) {
            setUniversityValues(universitiesValues !== null && universitiesValues !== void 0 ? universitiesValues : []);
        }
    };
    var clearFilters = function () {
        var _a;
        // props?.handleFilterApply({ name: props?.universityFieldName, value: null });
        (_a = props === null || props === void 0 ? void 0 : props.onClearFilter) === null || _a === void 0 ? void 0 : _a.call(props);
        handleClose(true);
    };
    var handleApply = function () {
        props === null || props === void 0 ? void 0 : props.handleFilterApply({ name: props === null || props === void 0 ? void 0 : props.universityFieldName, value: universityValues });
        handleClose(true);
    };
    var values = universitiesValues !== null && universitiesValues !== void 0 ? universitiesValues : [];
    var displayValue = highOfferInstituteValue && isFalsy(values)
        ? 'High Offer Institutes'
        : (values === null || values === void 0 ? void 0 : values.length) > 1
            ? ((_b = (_a = values === null || values === void 0 ? void 0 : values[0]) === null || _a === void 0 ? void 0 : _a.label) === null || _b === void 0 ? void 0 : _b.substring(0, 8)) + "... ".concat((values === null || values === void 0 ? void 0 : values.length) - 1 ? "+ ".concat((values === null || values === void 0 ? void 0 : values.length) - 1) : '')
            : __spreadArray([], __read((_c = (values !== null && values !== void 0 ? values : [])) === null || _c === void 0 ? void 0 : _c.map(function (o) { return o === null || o === void 0 ? void 0 : o.label; })), false).filter(function (o) { return !isFalsy(o); }).join(', ');
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: function (event) {
                setAnchorEl(event.currentTarget);
            }, "data-hasValue": !isFalsy(displayValue) },
            React.createElement(TextInput, { label: "University", keepDefaultLabelBehaviour: true, className: classNames('lfc-w-[190px]  lfc-transition-all'), InputLabelProps: { shrink: open || !!displayValue }, size: "small", InputProps: {
                    readOnly: true,
                    endAdornment: (React.createElement(React.Fragment, null,
                        displayValue ? (React.createElement(IconButton, { onClick: function (event) {
                                event.stopPropagation();
                                clearFilters();
                            } },
                            React.createElement(DropdownClose, { size: "small" }))) : null,
                        React.createElement(DropdownDownArrow, { size: "small", classNames: classNames('', { 'lfc-rotate-180': open }) }))),
                    sx: function (theme) {
                        var _a, _b, _c, _d, _e, _f;
                        return displayValue && !open
                            ? {
                                '&.MuiOutlinedInput-root': {
                                    backgroundColor: (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a['200'],
                                    fieldSet: {
                                        borderColor: (_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b['500']
                                    },
                                    ':hover': {
                                        backgroundColor: (_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c['200'],
                                        fieldSet: {
                                            borderColor: (_d = theme.palette.primary) === null || _d === void 0 ? void 0 : _d['500']
                                        }
                                    },
                                    '.MuiInputAdornment-positionStart': {
                                        '.MuiTypography-root': {
                                            color: (_e = theme.palette.primary) === null || _e === void 0 ? void 0 : _e['500']
                                        }
                                    },
                                    input: {
                                        textOverflow: 'ellipsis',
                                        color: (_f = theme.palette.primary) === null || _f === void 0 ? void 0 : _f['500']
                                    }
                                }
                            }
                            : {
                                '&.MuiOutlinedInput-root': {
                                    backgroundColor: 'white'
                                }
                            };
                    }
                }, value: displayValue, inputRef: inputRef })),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: function () {
                handleClose();
            }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, transformOrigin: { vertical: 0, horizontal: 0 }, slotProps: { paper: { sx: { overflow: 'visible' }, elevation: 0 } }, className: "lfc-mt-1 " },
            React.createElement("div", { className: "lfc-w-[350px] lfc-flex lfc-flex-col  lfc-gap-3 lfc-rounded-md lfc-border lfc-shadow-lg" },
                React.createElement("div", { className: "lfc-px-4" },
                    React.createElement(Checkboxes, { options: showHighOfferChangesOptions, onChange: function (values) {
                            props === null || props === void 0 ? void 0 : props.handleFilterApply({
                                name: props === null || props === void 0 ? void 0 : props.showOpenOnlyFieldName,
                                value: {
                                    label: 'High offer Institute',
                                    value: !highOfferInstituteValue
                                }
                            });
                            handleClose(true);
                        }, value: highOfferInstituteValue ? [highOfferInstituteValue] : [] })),
                React.createElement("div", { className: "lfc-flex lfc-gap-2 lfc-flex-col lfc-px-4" },
                    React.createElement(TextInput, { label: "Universities", value: searchQuery, onChange: function (event) {
                            setSearchQuery(event.target.value);
                        }, placeholder: "Search university", size: "small" }),
                    React.createElement("div", { className: "lfc-h-[152px]  lfc-overflow-y-auto lfc-overflow-x-visible lfc-px-4" },
                        React.createElement(Checkboxes, { options: filteredUniversityOptions, renderOptionLabel: function (option) { return (React.createElement("div", { className: "lfc-flex lfc-justify-between lfc-w-full" },
                                React.createElement(GBTypography, { variant: "body4Semibold" }, option === null || option === void 0 ? void 0 :
                                    option.label,
                                    (option === null || option === void 0 ? void 0 : option.count) && (React.createElement(GBTypography, { variant: "caption1", className: "lfc-ml-1" },
                                        "(",
                                        option.count,
                                        ")"))),
                                (option === null || option === void 0 ? void 0 : option.defaultLabel) === 'PREFERRED_INSTITUTE' && (React.createElement(GBTypography, { variant: "cta5", className: "lfc-rounded-md lfc-w-fit lfc-bg-success-100 lfc-px-2 lfc-text-success-700  lfc-flex lfc-items-center " },
                                    React.createElement("span", { className: "lfc-mr-1" },
                                        React.createElement(TaskAltIcon, { style: __assign({}, fontTokens.cta5) })),
                                    "H")))); }, formControlLabelProps: {
                                componentsProps: {
                                    typography: {
                                        sx: {
                                            width: '100%'
                                        }
                                    }
                                }
                            }, onChange: function (values) {
                                setUniversityValues(values !== null && values !== void 0 ? values : []);
                            }, value: universityValues !== null && universityValues !== void 0 ? universityValues : [], isOptionEqualToValue: function (option, value) { return (option === null || option === void 0 ? void 0 : option.value) === (value === null || value === void 0 ? void 0 : value.value); } }))),
                React.createElement("div", { className: "lfc-flex lfc-flex-col" },
                    React.createElement(Divider, null),
                    React.createElement("div", { className: "lfc-self-end lfc-p-2 lfc-flex lfc-gap-2" },
                        React.createElement(Button, { variant: "tertiary", onClick: function () {
                                clearFilters();
                            } }, "Clear"),
                        React.createElement(Button, { onClick: function () {
                                handleApply();
                            } }, "Apply")))))));
};
export default UniversityCFFilter;
//# sourceMappingURL=UniversityCFFilter.js.map